var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-like",on:{"click":_vm.clickLike}},[_c('div',{ref:"animationRef",staticClass:"animation"}),(!_vm.runningAnimation)?_c('span',{staticClass:"icon",class:_vm.dynamicClass}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }